
const lang = {

  'en-GB': {

    menu: {
      left: {
        start: 'Start',
        employees: 'Employees',
        projects: 'Projects',
        planning: 'Planning',
      },
      right: {
        login: 'Login',
        logout: 'Logout',
      },
    },

    validations: {
      required: 'Required.',
      min: length => `Min ${length} characters.`,
      max: length => `Max ${length} characters.`,
      exists: 'Already exists.',
    },

    pages: {
      start: {
        title: 'Home',
        menuTitle: 'Home',
        employees: 'Employees',
        projects: 'Projects',
        planning: 'Planning',
        departmentNotification: number => `Department ${number} is missing employees for next 12 months.`,
        projectNotification(project, departments) {
          if (departments.length === 1) {
            return `Project ${project} is missing planning for department ${departments[0]}.`;
          }
          const lastDepartment = departments.pop();
          return `Project ${project} is missing planning for departments ${departments.join(',')} and ${lastDepartment}.`;
        },
      },
      employees: {
        title: 'Employees',
        menuTitle: 'Employees',
        departmentLabel: 'Department',
        employed: 'Employed',
        absence: 'Absence',
        available: 'Available',
      },
      projects: {
        title: 'Projects',
        menuTitle: 'Projects',
        departmentLabel: 'Department',
        categoryLabel: 'Category',
        statusLabel: 'Status',
        searchLabel: 'Search',
        searchPlaceholder: 'Search...',
        allDepartmentsItem: 'All Departments',
        allCategoriesItem: 'All Categories',
        allStatusesItem: 'All Statuses',
        table: {
          name: 'Name',
          responsible: 'Responsible',
          number: 'Number',
          owner: 'Owner',
          category: 'Category',
          orderValue: 'Order Value',
          department: 'Department',
          status: 'Status',
          actions: 'Actions',
        },
        active: 'Active',
        summary: 'Summary',
        cantBeDeletedMessage: 'This project can\'t be deleted because it has planning.',
        duplicateMessage: number => `There is already another project using ${number} as a Number.`,
        modals: {
          add: {
            title: 'Add Project',
            name: 'Name',
            responsible: 'Responsible',
            number: 'Number',
            orderValue: 'Order Value',
            category: 'Category',
            owner: 'Owner',
            departments: 'Departments',
            closeButton: 'Close',
            createButton: 'Create',
          },
          remove: {
            title: 'Remove Project',
            text: 'Are you sure you want to remove this project?',
            closeButton: 'Close',
            removeButton: 'Yes, remove it',
          },
        },
      },
      planning: {
        title: 'Planning',
        menuTitle: 'Planning',
        departmentLabel: 'Department',
        projectLabel: 'Project',
        filterLabel: 'Filter',
        searchLabel: 'Search',
        searchPlaceholder: 'Search...',
        allDepartmentsItem: 'All Departments',
        allProjectsItem: 'All Projects',
        noFilterItem: 'No Filter',
        missingPlanningItem: 'Missing Planning',
        table: {
          owner: 'Owner',
          department: 'Department',
          project: 'Project',
        },
        card: {
          owner: 'Owner',
          category: 'Category',
          status: 'Status',
          orderValue: 'OrderValue',
          departments: 'Departments',
        },
        summary: 'Summary',
        plannedHours: 'Planned hours',
        availableHours: 'Available hours',
        occupancyRate: 'Occupancy Rate',
      },
    },

    table: {
      pagination: {
        rowsPerPage: 'Rows per page:',
        allItem: 'All',
      },
      noResults: 'No matching records found.',
      noRecords: 'There are no records.',
    },
  },


  //

  'sv-SE': {

    menu: {
      left: {
        start: 'Start',
        employees: 'Anställda',
        projects: 'Projekt',
        planning: 'Beläggning',
      },
      right: {
        login: 'Logga in',
        logout: 'Logga ut',
      },
    },

    validations: {
      required: 'Krav.',
      min: length => `Min ${length} tecken.`,
      max: length => `Max ${length} tecken.`,
      exists: 'Finns redan.',
    },

    pages: {
      start: {
        title: 'Start',
        menuTitle: 'Start',
        employees: 'Anställda',
        projects: 'Projekt',
        planning: 'Beläggning',
        departmentNotification: number => `Avdelning ${number} saknar information om antal anställda.`,
        projectNotification(project, departments) {
          if (departments.length === 1) {
            return `Projekt ${project} saknar beläggning för avdelning ${departments[0]}.`;
          }
          const lastDepartment = departments.pop();
          return `Projekt ${project} saknar beläggning för avdelningarna ${departments.join(',')} och ${lastDepartment}.`;
        },
      },
      employees: {
        title: 'Anställda',
        menuTitle: 'Anställda',
        departmentLabel: 'Avdelning',
        employed: 'Anställda',
        absence: 'Frånvarande',
        available: 'Tillgängliga',
      },
      projects: {
        title: 'Projekt',
        menuTitle: 'Projekt',
        departmentLabel: 'Avdelning',
        categoryLabel: 'Kategori',
        statusLabel: 'Status',
        searchLabel: 'Sök',
        searchPlaceholder: '...',
        allDepartmentsItem: 'Alla avdelningar',
        allCategoriesItem: 'Alla kategorier',
        allStatusesItem: 'Alla statusar',
        table: {
          name: 'Namn',
          responsible: 'Uppdragsansvarig',
          number: 'Nummer',
          owner: 'Ägare',
          category: 'Kategori',
          orderValue: 'Ordervärde',
          department: 'Avdelning',
          status: 'Status',
          actions: 'Funktion',
        },
        active: 'Aktivt',
        summary: 'Summa',
        cantBeDeletedMessage: 'Detta projekt går inte att radera då det redan är belagt.',
        duplicateMessage: number => `Det finns redan ett projekt med samma (${number}) nummer.`,
        modals: {
          add: {
            title: 'Skapa projekt',
            name: 'Namn',
            responsible: 'Uppdragsansvarig',
            number: 'Nummer',
            orderValue: 'Ordervärde',
            category: 'Kategori',
            owner: 'Ägare',
            departments: 'Avdelning',
            closeButton: 'Stäng',
            createButton: 'Skapa',
          },
          remove: {
            title: 'Radera projekt',
            text: 'Är du säker att du vill radera detta projekt?',
            closeButton: 'Nej, stäng',
            removeButton: 'Ja, radera projekt',
          },
        },
      },
      planning: {
        title: 'Beläggning',
        menuTitle: 'Beläggning',
        departmentLabel: 'Avdelning',
        projectLabel: 'Projekt',
        filterLabel: 'Filter',
        searchLabel: 'Sök',
        searchPlaceholder: '...',
        allDepartmentsItem: 'Alla avdelningar',
        allProjectsItem: 'Alla projekt',
        noFilterItem: 'Inget filter',
        missingPlanningItem: 'Saknar beläggning',
        table: {
          owner: 'Ägare',
          department: 'Avdelning',
          project: 'Projekt',
        },
        card: {
          owner: 'Ägare',
          category: 'Kategori',
          status: 'Status',
          orderValue: 'Ordervärde',
          departments: 'Avdelning',
        },
        summary: 'Summa',
        plannedHours: 'Planerade timmar',
        availableHours: 'Tillgängliga timmar',
        occupancyRate: 'Beläggningsgrad',
      },
    },

    table: {
      pagination: {
        rowsPerPage: 'Resultat per sida:',
        allItem: 'Alla',
      },
      noResults: 'Inga matchande  uppgifter hittades.',
      noRecords: 'Det finns inga poster.',
    },
  },
};

let defaultLanguage = 'sv-SE';
if (navigator) {
  const browserLanguage = navigator.language || navigator.userLanguage; // eslint-disable-line
  if (browserLanguage in lang) {
    defaultLanguage = browserLanguage;
  }
}

export default function language(path, ...args) {
  const result = path.split('.').reduce((acc, part) => {
    if (!(part in acc)) {
      const err = new Error(`Language constant '${path}' not found.`);
      err.code = 'LANGUAGE_CONSTANT_NOT_FOUND';
      throw err;
    }
    return acc[part];
  }, lang[defaultLanguage]);

  // auto call the function
  if (typeof result === 'function' && args && args.length) {
    return result(...args);
  }

  return result;
}
